import React, { useState, useEffect } from 'react'
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';

function Addquiz(){
    const apiUrl = API_URL;
    const [items, setItems] = useState([]);
    const [successMessages, setSuccessMessages] = useState([]);
    const [optiontype, setOptiontype] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    // valuetosend
    const [question,setQuestion]=useState("");
    const [fromtype, setFromtype]=useState([]);
    const [usertype, setUsertype]=useState([]);
    const [answertype, setAnswertype]=useState([]);
    const [options, setOptions]=useState([]);
    const [fromvalue, setFromvalue]=useState([]);
    const [tovalue, setTovalue]=useState([]);
    const [questionOrder, setQuestionOrder]=useState([]);
    // valuetosend

    // Industry
    useEffect(() => {
        const getComments = async () => {
          try{
            const res = await fetch(`${apiUrl}/industrylist`,{
                method:'GET',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
            });
            const data = await res.json();
            if(data.status !== 200){
              throw new Error('Data not found');
            }
            setItems(data.data);
          }catch(error){
            console.error('Error ', error)
          }
        };
        getComments();
      }, []);
    // Industry
    const timeOptions = [];
    for (let hour = 7; hour<=21; hour++){
        for (let minute = 0; minute<60; minute+=15){
            const formattedHour = hour.toString().padStart(2,0);
            const formattedMinute = minute.toString().padStart(2,0);
            const timeString = `${formattedHour}${formattedMinute}`;
            timeOptions.push(timeString);
        }
    }
    const Selectoptiontype = (e) => {
        var getoptiontype = e.target.value;
        setAnswertype(getoptiontype);
       if(getoptiontype == "options"){
            var answerOption = 
            <div>
                <span>Enter Options with comma separated</span>
                <div className="col-sm-3 mt-3">
                    <input type="text" className="form-control" id="options" placeholder="Enter Options" onChange={(e)=>setOptions(e.target.value)}/>
                </div>
            </div>          
            setOptiontype(answerOption); 
        }
        else if(getoptiontype == "time"){
            answerOption = 
            <div>
                From
                <select className="form-select col-sm-2 selectBox mt-2 mb-2" onChange={(e)=>setFromvalue(e.target.value)}>
                    <option value="">Select Time</option>
                    {timeOptions.map((time) => (
                        <option key={time} value={time}>
                            {`${time.substring(0,2)}:${time.substring(2)}`}
                        </option>
                    ))}
                </select>
                To
                <select className="form-select col-sm-2 selectBox mt-2"  onChange={(e)=>setTovalue(e.target.value)}>
                    <option value="">Select Time</option>
                    {timeOptions.map((time) => (
                        <option key={time} value={time}>
                            {`${time.substring(0,2)}:${time.substring(2)}`}
                        </option>
                    ))}
                </select>
            </div>
            setOptiontype(answerOption); 
        }
        else{
            answerOption = '';
            setOptiontype(answerOption); 
        }
    }
    var enterValue = '';
    if(options != ''){
        enterValue = options
    }
    else if((fromvalue!='') && (tovalue!='')){
        enterValue = fromvalue+' - '+tovalue;
    }
    const clicktoaddquiz = async (e) => {
        e.preventDefault();
        // console.log(fromtype);
        const postData = {
            industry_id:selectedOptions,
            from_type:fromtype,
            question:question,
            answer_type:answertype,
            enterValue:enterValue,
            questionOrder: questionOrder,
            user_type: usertype
        };
        console.log(postData);
        const result = await fetch(`${apiUrl}/admin/addquiz`,{
            method:'POST',
            headers:{
                "Content-Type":"application/json",
                "Accept":"application/json"
            },
            body:JSON.stringify(postData)
        });
        const data = await result.json();
        if((data.status === 200)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }else if((data.status === 400)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }
        // setsubcategory(' ');
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        // window.location.reload();
    }
    const handleOption = (e) => {
        var getValue = (e.target.value);
        if(selectedOptions.includes(getValue)){
            setSelectedOptions(selectedOptions.filter((data)=>data!=getValue));
        }else{
            setSelectedOptions([...selectedOptions, getValue]);
        }
    }
    return (
        <div className='width90'>
            <h2 className='pageTitle'>Add Quiz</h2>
            <div className='commonCntr'>
                <form className="form-horizontal" onSubmit={clicktoaddquiz}> 
                    <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="industrytype">Industry Type:</label>
                        <select multiple className="form-select col-sm-5 selectBox" value={selectedOptions} onChange={()=>{}}>
                            {items.map((item , index) => {
                                return(<option value={item.id} onClick={handleOption}>{item.industry_name}</option>
                            )})}
                        </select>
                    </div>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label" htmlFor="options">From Type:</label>
                    </div> 
                    <select className="form-select col-sm-5 selectBox" onChange={(e)=>setFromtype(e.target.value)} >
                        <option value="">Select From type</option>
                        <option value="creator">Creator</option>
                        <option value="provider">Provider</option>
                    </select>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label" htmlFor="options">User Type:</label>
                    </div> 
                    <select className="form-select col-sm-5 selectBox" onChange={(e)=>setUsertype(e.target.value)} >
                        <option value="">Select From type</option>
                        <option value="Provider">Provider</option>
                        <option value="Employer">Employer</option>
                        <option value="Homeowner">Homeowner</option>
                    </select>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label" htmlFor="question">Question:</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control" id="question" onChange={(e)=>setQuestion(e.target.value)} placeholder="Question" />
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label" htmlFor="options">Answer Type:</label>
                    </div> 
                    <select className="form-select col-sm-5 selectBox" onChange={Selectoptiontype}>
                        <option value="">Select Answer type</option>
                        <option value="yes_no">Yes/No</option>
                        <option value="options">Options</option>
                        {/* <option value="text">Textual Option</option> */}
                        <option value="numeric">Numeric Value</option>
                        <option value="time">Time</option>
                        {/* <option value="alert">Alert</option> */}
                    </select>
                    <div className='mt-3'>
                        {optiontype} 
                    </div>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label" htmlFor="questionOrder">Question Order:</label>
                    </div> 
                    <input type="number"  onChange={(e)=>setQuestionOrder(e.target.value)} />
                    {/* <select className="form-select col-sm-5 selectBox" >
                        <option value="">Select Question Order</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                    </select> */}
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="submit" className="btn btn-default submitBtn">Submit</button>
                        </div>
                    </div>
                </form>
                    {
                        successMessages.map((message, index) => (
                            <SuccessMessage
                                key={index} 
                                message = {message} 
                                onFadeOut={handleSuccessMessageFadeOut}
                            />
                        )
                    )}
            </div>
        </div>
    )
}

export default Addquiz;